// Canonical epic order — matches the parser keys on the API side, so the same
// epic always gets the same color regardless of what's in the fetched date range.
const EPIC_COLOR_ORDER = [
  "Journey to the Inferno",
  "Titans' Keep",
  "Winds of Fate",
  "Oradrin's Chosen",
  "Transcendence",
  "Icefall 1",
  "Icefall 2",
  "Genie's Last Wish",
  "The Cracks of Terra",
  "Sea King's Dominion"
];

// Categorical palette, dark-surface steps — 5 hue families x 2 lightness
// tiers, chosen by sweeping hue/lightness/chroma and maximizing the
// worst-case pairwise OKLab separation (see dataviz skill's
// validate_palette.js) against this app's dark surface (#161523). Lightness
// band, chroma floor, and contrast all pass; CVD/normal-vision separation is
// as good as is achievable for this many categorical slots (the skill's own
// default 8-hue set can't clear all-pairs separation past 4 slots either) —
// identity still relies on the always-visible name label next to each
// swatch, not color alone.
// Icefall 1/2 and Transcendence are explicit brand overrides (white / yellow)
// requested directly, not part of the swept set.
const EPIC_PALETTE = [
  "#ae4567", // magenta, dark tier — Journey to the Inferno
  "#00829d", // teal, dark tier — Titans' Keep
  "#956300", // amber, dark tier — Winds of Fate
  "#25833a", // green, dark tier — Oradrin's Chosen
  "#f5c518", // yellow (explicit override) — Transcendence
  "#ffffff", // white (explicit override) — Icefall 1
  "#ffffff", // white (explicit override) — Icefall 2
  "#c38400", // amber, light tier — Genie's Last Wish
  "#4fa95d", // green, light tier — The Cracks of Terra
  "#9381e1" // violet, light tier — Sea King's Dominion
];

const FALLBACK_COLOR = "#7a7894";

const hashName = (name: string): number => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return hash;
};

export const getEpicColor = (epicName?: string | null): string => {
  if (!epicName) return FALLBACK_COLOR;
  const knownIndex = EPIC_COLOR_ORDER.indexOf(epicName);
  if (knownIndex >= 0) return EPIC_PALETTE[knownIndex];
  return EPIC_PALETTE[hashName(epicName) % EPIC_PALETTE.length];
};
